module.exports = __webpack_public_path__ + "static/img/pickup-doublecab-orange.986b245.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pickup-doublecab-orange.svg
// module id = LwCX
// module chunks = 82